var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_992680",
    clipPath: "url(#clip0_1491_2501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.6332 12.2079H1.77438C1.47637 12.2079 1.23452 11.966 1.23452 11.6681V1.95043C1.23452 1.65242 1.47639 1.41057 1.77438 1.41057H6.6332C6.93175 1.41057 7.17306 1.16926 7.17306 0.870717C7.17306 0.572174 6.93175 0.330811 6.6332 0.330811H1.77438C0.881439 0.330811 0.154785 1.05749 0.154785 1.95043V11.668C0.154785 12.561 0.881439 13.2876 1.77438 13.2876H6.6332C6.93175 13.2876 7.17306 13.0463 7.17306 12.7478C7.17306 12.4492 6.93175 12.2079 6.6332 12.2079Z",
    fill: "#8C8C76"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9938 6.42491L9.71141 3.1857C9.49978 2.97623 9.15752 2.97894 8.94805 3.19111C8.73857 3.40327 8.74073 3.745 8.95345 3.95447L11.2992 6.26941H5.01349C4.71495 6.26941 4.47363 6.51073 4.47363 6.80927C4.47363 7.10781 4.71495 7.34915 5.01349 7.34915H11.2992L8.95345 9.66409C8.74076 9.87356 8.73913 10.2153 8.94805 10.4275C9.05385 10.5344 9.19314 10.5883 9.33243 10.5883C9.46957 10.5883 9.60668 10.5365 9.71141 10.4328L12.9938 7.19363C13.0964 7.09215 13.1547 6.95392 13.1547 6.80924C13.1547 6.66462 13.0969 6.52695 12.9938 6.42491Z",
    fill: "#8C8C76"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_2501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.154785 0.309326)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.7ecfeccd68e4c14c27010a9a8fd62d17.svg";
export { ForwardRef as ReactComponent };